<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  methods: {
    handleKeyDown(e) {
      // 修正后的判断条件
      if (e.shiftKey && e.altKey && e.code === 'KeyX') {
        window?.bridge?.send('universal-channel', {
          action: 'execute',
          name: 'ScreenCapture',
        });
        e.preventDefault();

        // 可选：检查是否系统快捷键被覆盖
        if (e.ctrlKey || e.metaKey) {
          console.warn('检测到额外修饰键，可能被系统占用');
        }
      }
    }
  },

  // 在生命周期钩子中添加/移除事件监听
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  height: 100%;
  width: 100%;
  color: var(--im-text-color);
  font-family: var(--im-font-family);
}
</style>
